import React, { Component } from "react";
import ReactFlexyTable from "react-flexy-table";
import "react-flexy-table/dist/index.css";
import ExcelQueryTraySubReport from "./ExcelQueryTraySubReport";

interface AllProps {
  reports: any[];
  redirectToDashboard?: (id: number) => void;
  showMoveToProcess?: boolean;
  selectedFileIds?: number[];
  isMovingToProcess?: boolean;
  onToggleFile?: (fileId: number) => void;
  onToggleAll?: (fileIds: number[]) => void;
  onMoveToProcess?: () => void;
}

export default class QueryTrayReportTable extends Component<AllProps> {
  render() {
    const {
      reports = [],
      redirectToDashboard = () => {},
      showMoveToProcess = false,
      selectedFileIds = [],
      isMovingToProcess = false,
      onToggleFile = () => {},
      onToggleAll = () => {},
      onMoveToProcess = () => {},
    } = this.props;

    const cell = (item: any, key: string) => (
      <span onClick={() => redirectToDashboard(item.id)} style={{ whiteSpace: "pre-line" }}>
        {item[key] || "-"}
      </span>
    );

    const processedData = reports.map((report, index) => ({
      ...report,
      serial: index + 1,
      query_raised_dt: report.query_raised_dt || report.initial_query_raised_dt || report.query_date || "",
      query_details: report.query_details || report.initial_query_details || "",
      move_to_process_dt: report.move_to_process_dt || report.full_query_received_dt || "",
      query_received_details:
        report.query_received_details || report.fully_query_details || report.full_query_received_details || "",
      pending_query_details: report.pending_query_details || "",
    }));

    const allFileIds = processedData.map((item) => Number(item.id)).filter((id) => id > 0);
    const allSelected = allFileIds.length > 0 && allFileIds.every((id) => selectedFileIds.includes(id));

    const displayColumns = [
      ...(showMoveToProcess
        ? [
            {
              header: "Select",
              key: "select",
              td: (item: any) => (
                <input
                  type="checkbox"
                  checked={selectedFileIds.includes(Number(item.id))}
                  onChange={(e) => {
                    e.stopPropagation();
                    onToggleFile(Number(item.id));
                  }}
                  onClick={(e) => e.stopPropagation()}
                />
              ),
            },
          ]
        : []),
      { header: "S.No", key: "serial", td: (item: any) => cell(item, "serial") },
      { header: "File No", key: "file_no", td: (item: any) => cell(item, "file_no") },
      { header: "Law Hands Branch Name", key: "lh_branch_name", td: (item: any) => cell(item, "lh_branch_name") },
      { header: "Bank Name", key: "bank_name", td: (item: any) => cell(item, "bank_name") },
      { header: "Product", key: "product", td: (item: any) => cell(item, "product") },
      { header: "Grade", key: "grade", td: (item: any) => cell(item, "grade") },
      { header: "Bank Branch Name", key: "bank_branch_name", td: (item: any) => cell(item, "bank_branch_name") },
      { header: "Borrower Name", key: "borrower_name", td: (item: any) => cell(item, "borrower_name") },
      { header: "Property Owner Name", key: "owner_name", td: (item: any) => cell(item, "owner_name") },
      { header: "App Id", key: "app_id", td: (item: any) => cell(item, "app_id") },
      { header: "Login Date", key: "login_date", td: (item: any) => cell(item, "login_date") },
      { header: "Query Raised by", key: "query_raised_by", td: (item: any) => cell(item, "query_raised_by") },
    ];

    return (
      <div>
        <div className="row">
          <div className="col-xl-12 col-md-12 p-3 query-tray-subreport-actions">
            {showMoveToProcess && processedData.length > 0 ? (
              <div className="query-tray-subreport-toolbar">
                <label className="query-tray-subreport-select-all">
                  <input
                    type="checkbox"
                    checked={allSelected}
                    disabled={isMovingToProcess}
                    onChange={() => onToggleAll(allFileIds)}
                  />
                  <span>Select All</span>
                </label>
                <button
                  type="button"
                  className="btn query-tray-subreport-move-btn"
                  disabled={selectedFileIds.length === 0 || isMovingToProcess}
                  onClick={onMoveToProcess}
                >
                  {isMovingToProcess ? (
                    <>
                      <i className="fa fa-spinner fa-spin" aria-hidden="true"></i> Moving...
                    </>
                  ) : (
                    <>
                      <i className="fa fa-arrow-right" aria-hidden="true"></i> Move to Process
                    </>
                  )}
                </button>
              </div>
            ) : null}
            {processedData.length > 0 && <ExcelQueryTraySubReport data={processedData} />}
          </div>
        </div>
        <ReactFlexyTable
          className="assigned-table"
          data={processedData}
          columns={displayColumns}
          sortable
          pageSize={10}
          globalSearch
        />
      </div>
    );
  }
}
